import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const MobileCtx = createContext(null);
export const useMobile = () => useContext(MobileCtx);

export const MobileProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [guestId, setGuestId] = useState(() => localStorage.getItem('azizi_guest_id'));
  const [guest, setGuest] = useState(() => { try { return JSON.parse(localStorage.getItem('azizi_guest') || 'null'); } catch { return null; } });
  const [lang, setLangState] = useState(() => localStorage.getItem('azizi_m_lang') || 'ar');
  const [content, setContent] = useState({ services: [], links: [], bank: {}, kind: 'guest' });
  const [loading, setLoading] = useState(true);
  const [installEvt, setInstallEvt] = useState(null);
  const isRTL = lang === 'ar';

  const headers = useCallback(() => {
    const h = {};
    if (token && user?.role === 'client') h.Authorization = `Bearer ${token}`;
    if (guestId) h['X-Guest-Id'] = guestId;
    return h;
  }, [token, user, guestId]);

  useEffect(() => {
    if (guestId || (user && user.role === 'client')) return;
    axios.post(`${API}/m/guest`, { lang }).then(r => { localStorage.setItem('azizi_guest_id', r.data.id); localStorage.setItem('azizi_guest', JSON.stringify(r.data)); setGuestId(r.data.id); setGuest(r.data); }).catch(() => {});
  }, [guestId, user]);

  const refresh = useCallback(async () => {
    try { const r = await axios.get(`${API}/m/content`, { headers: headers() }); setContent(r.data); } catch {}
    setLoading(false);
  }, [headers]);
  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener('beforeinstallprompt', h);
    if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {});
    const link = document.querySelector('link[rel="manifest"]'); if (link) link.setAttribute('href', '/manifest.json');
    return () => window.removeEventListener('beforeinstallprompt', h);
  }, []);

  const setLang = (l) => { localStorage.setItem('azizi_m_lang', l); setLangState(l); };
  const updateGuest = async (data) => {
    if (!guestId) return;
    const r = await axios.put(`${API}/m/guest/${guestId}`, data, { headers: headers() });
    localStorage.setItem('azizi_guest', JSON.stringify(r.data)); setGuest(r.data);
  };
  const t = (ar, en) => (isRTL ? ar : en);
  const isClient = !!(user && user.role === 'client');
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

  return (
    <MobileCtx.Provider value={{ API, headers, guestId, guest, updateGuest, lang, setLang, isRTL, t, content: { ...content, loading }, refresh, loading, isClient, user, installEvt, setInstallEvt, isIOS, isStandalone }}>
      {children}
    </MobileCtx.Provider>
  );
};
